import { render, staticRenderFns } from "./OrderUserInfo.vue?vue&type=template&id=b518d526&scoped=true&"
import script from "./OrderUserInfo.vue?vue&type=script&lang=js&"
export * from "./OrderUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrderUserInfo.vue?vue&type=style&index=0&id=b518d526&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b518d526",
  null
  
)

export default component.exports